import React, { useEffect } from "react";
import Divider from "../../components/common/titles/Divider";

import { Container } from "react-bootstrap";

import { AUTH_API_URL } from "../../config/constants";
import { useRouter } from "next/router";

function UnsubscribePage() {
  const { query } = useRouter();

  useEffect(() => {
    const { hash, email } = query;

    if (!(hash && email)) return;

    fetch(`${AUTH_API_URL}/subscribe/email`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, hash }),
    })
      .then((res) => {})
      .catch((e) => console.log(e));
  }, []);

  return (
    <Container fluid="xl" as="main" className="pt-3 pt-md-4 pt-lg-5">
      <h1 className="fw-bold">Unsubscribe</h1>
      <Divider />
      <div className="text-center pt-3 h3">
        <p>You have successfully unsubscribed from all email communications.</p>
      </div>

      <div className="text-center pt-3 h6">
        <p>
          You'll no longer receive our messages, but you can change your
          decision at any time.
        </p>
      </div>
    </Container>
  );
}

export default UnsubscribePage;
